// extracted by mini-css-extract-plugin
export default {"container":"Avatar_container__tCE10","placeholder":"Avatar_placeholder__djo93","avatarImg":"Avatar_avatarImg__-iveD"};